/**
 * Утилита для работы с Яндекс Метрикой.
 * Инициализирует счётчик через нативный tag.js API.
 */

const METRIKA_ID = import.meta.env.VITE_YANDEX_METRIKA_ID
  ? parseInt(import.meta.env.VITE_YANDEX_METRIKA_ID, 10)
  : 0

let initialized = false

export function initMetrika() {
  if (initialized || METRIKA_ID <= 0 || typeof window === 'undefined') return
  initialized = true

  ;(function (m, e, t, r, i, k, a) {
    m[i] =
      m[i] ||
      function () {
        ;(m[i].a = m[i].a || []).push(arguments)
      }
    m[i].l = 1 * new Date()
    for (let j = 0; j < document.scripts.length; j++) {
      if (document.scripts[j].src === r) return
    }
    k = e.createElement(t)
    a = e.getElementsByTagName(t)[0]
    k.async = 1
    k.src = r
    a.parentNode.insertBefore(k, a)
  })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym')

  window.ym(METRIKA_ID, 'init', {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: true,
  })
}

export function reachGoal(goal, params) {
  if (METRIKA_ID <= 0 || typeof window === 'undefined' || !window.ym) return
  window.ym(METRIKA_ID, 'reachGoal', goal, params)
}

export const metrikaId = METRIKA_ID
